<script lang="ts">import { icon, iconActive, iconHover } from "./colors";
export let size = 16;
export let active = false;
export let hover = false;
export let color = undefined;
let width = size;
let height = size;
let fill = color ? color : active ? iconActive : hover ? iconHover : icon;
$: fill = color ? color : active ? iconActive : hover ? iconHover : icon;
</script>

<svg {width} {height} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g clip-path="url(#clip0_6414_104524)">
		<path
			d="M8.06231 9.32057C8.01252 9.27582 7.94779 9.24598 7.88803 9.21117C7.90795 9.1863 7.92787 9.16144 7.94281 9.13657C8.0175 9.13657 8.09218 9.13657 8.16189 9.13657C10.8457 9.13657 14.2664 9.13657 17 9.13657C16.6813 13.5874 12.8921 17.0734 8.34612 16.9988C3.6806 16.9193 -0.0687525 13.0403 0.000956514 8.36079C0.0756448 3.67129 3.96939 -0.0783234 8.67973 0.00124359C13.0067 0.0758381 16.527 3.39777 16.9751 7.61982C14.6598 7.61982 11.6872 7.61982 9.43657 7.61982C8.96355 7.61982 8.49052 7.61982 7.9677 7.61982C8.03741 7.54522 8.08222 7.49549 8.12704 7.45074C8.76438 6.8142 9.4067 6.17766 10.0391 5.53615C10.532 5.03388 10.3328 4.22826 9.67059 4.04426C9.3569 3.95475 9.05815 4.0194 8.82413 4.25313C7.66397 5.40685 6.50879 6.56555 5.34863 7.71928C5.05486 8.01268 5.01503 8.6542 5.36357 8.99733C6.54365 10.1461 7.69883 11.3197 8.86894 12.4834C9.22744 12.8414 9.6208 12.8365 9.97931 12.4883C10.1486 12.3242 10.298 12.1601 10.3079 11.9065C10.3179 11.6628 10.2183 11.4788 10.054 11.3098C9.39176 10.6484 8.72952 9.98198 8.06231 9.32057Z"
			{fill}
		/>
	</g>
	<defs>
		<clipPath id="clip0_6414_104524">
			<rect width="17" height="17" {fill} transform="matrix(1 0 0 -1 0 17)" />
		</clipPath>
	</defs>
</svg>
